// ============================================================================
// RUSSIAN TRANSLATIONS - UI
// ============================================================================

import unityTranslations from './unity.js';
export const uiTranslations = {
  meta: {
    language: 'ru',
    languageName: 'Русский',
    version: '1.0'
  },
  
  app: {
    title: "UNITYQUEST Хроники\nЛюбви",
    subtitle: "Интерактивное Изучение Писаний",
    tagline: "Идти к божественному свету",
    menu: "Меню",
    retry: "Повторить"
  },
  
  buttons: {
    play: "ИГРАТЬ",
    back: "Назад",
    continue: "Продолжить",
    restart: "Начать заново",
    close: "Закрыть",
    nextLevel: "Следующий Уровень",
    selectLevel: "Выбор Уровня",
    retry: "Повторить",
    mainMenu: "Главное Меню",
    start: "Начать",
    cancel: "Отмена",
    confirm: "Подтвердить",
    save: "Сохранить",
    load: "Загрузить",
    yesRestart: "Да, начать заново",
    noContinue: "Нет, продолжить",
    tryAgain: "Попробовать снова",
    backToMenu: "Вернуться в меню"
  },
  
  labels: {
    score: "Счет",
    stars: "Звезды",
    wisdom: "Мудрость",
    revelation: "Откровение",
    lives: "Жизни",
    combo: "Комбо",
    level: "УРОВЕНЬ",
    easy: "ЛЕГКО",
    medium: "СРЕДНЕ",
    hard: "СЛОЖНО",
    correct: "Правильно!",
    gameOver: "Испытание провалено",
    victory: "Победа!",
    completed: "Завершено",
    rank: "Духовный Ранг",
    points: "Очки Мудрости",
    unlockedLevels: "уровней разблокировано",
    questionOfKnowledge: "Вопрос знания",
    hintOfWisdom: "Подсказка мудрости",
    knowledgeMastered: "Знание освоено!",
    knowledgeAcquired: "Знание приобретено!",
    testFailed: "Испытание провалено",
    wisdomBonus: "Бонус",
    xpGained: "XP",
    newRank: "Новый ранг",
    nextGrade: "Следующий ранг",
    maxLevelReached: "Достигнут максимальный уровень!",
    wrongAnswer: "Неправильный ответ!"
  },
  
  menu: {
    playButton: "ИГРАТЬ",
    info: "Инфо",
    treasures: "Сокровища",
    john: "Иоанн",
    reset: "Сброс",
    resetConfirm: "Начать приключение заново?",
    resetWarning: "Вы уверены, что хотите стереть весь свой прогресс?",
    resetLose: "Вы потеряете:",
    wisdomPoints: "Очков Мудрости",
    starsCollected: "собранных звезд",
    levelsUnlocked: "разблокированных уровней",
    spiritualRank: "Духовный Ранг",
    yesRestart: "Да, начать заново",
    noContinue: "Нет, продолжить",
    newAdventure: "Новое Приключение",
    readyToStart: "Готовы начать?",
    startJourney: "Начните свое путешествие в знание Писаний!",
    audioControls: "Управление аудио",
    mute: "Отключить звук",
    unmute: "Включить звук",
    close: "Закрыть",
    language: "Язык",
    restartGame: "Перезапустить игру"
  },
  
  login: {
    title: "UNITY QUEST",
    subtitle: "Интерактивное библейское приключение",
    anonymousMode: "Играть Анонимно",
    anonymousDesc: "Выберите псевдоним",
    emailMode: "Вход по Email",
    emailDesc: "Сохранение на нескольких устройствах",
    pseudo: "Псевдоним",
    pseudoPlaceholder: "Ваш псевдоним...",
    email: "Email Адрес",
    emailPlaceholder: "ваш@email.com",
    startPlaying: "Начать играть",
    sendLink: "Отправить ссылку",
    sending: "Отправка...",
    connecting: "Подключение...",
    back: "Назад",
    localSave: "Ваш прогресс будет сохранен локально",
    cloudSync: "Пароль не требуется • Синхронизация в облаке",
    magicLink: "Получите магическую ссылку по email",
    checkEmail: "✉️ Проверьте свою почту! Ссылка для входа отправлена.",
    checkSpam: "Проверьте также папку спам",
    waitingConnection: "Ожидание подключения...",
    errorSend: "Ошибка отправки ссылки",
    rateLimited: "⏳ Пожалуйста, подождите 15 секунд перед повторной отправкой письма",
    importSession: "🔄 Импортировать сессию из продакшена",
    errorConnection: "Ошибка подключения",
    enterPseudo: "Пожалуйста, введите псевдоним",
    enterEmail: "Пожалуйста, введите действительный email",
    // Tooltips
    never: "Никогда",
    save: "Сохранить игру",
    lastSave: "последнее",
    refresh: "Перезагрузить прогресс",
    logout: "Выйти",
    connectToCloud: "Подключиться для сохранения онлайн",
    editPseudo: "Изменить имя",
    confirm: "Подтвердить",
    cancel: "Отменить",
    close: "Закрыть",
    passwordMode: "Простой Вход",
    passwordDesc: "Email + пароль",
    password: "Пароль",
    passwordPlaceholder: "Минимум 6 символов",
    passwordMinLength: "Минимум 6 символов",
    playWithoutAccount: "Играть без учетной записи",
    forgotPassword: "Забыли пароль?",
    resetPasswordTitle: "Сброс Пароля",
    resetPasswordSubtitle: "Введите email для получения ссылки сброса",
    sendResetLink: "Отправить Ссылку",
    resetEmailSent: "📧 Письмо для сброса отправлено! Проверьте почту.",
    errorReset: "Ошибка отправки письма",
    backToSignin: "Назад ко входу",
    newPassword: "Новый Пароль",
    enterNewPassword: "Выберите новый безопасный пароль",
    confirmPassword: "Подтвердите Пароль",
    updatePassword: "Обновить Пароль",
    passwordsDontMatch: "Пароли не совпадают",
    passwordUpdateSuccess: "✅ Пароль успешно обновлён!",
    errorUpdatePassword: "Ошибка обновления пароля",
    resetLinkExpired: "Ссылка сброса истекла или недействительна",
    forgotPassword: "Забыли пароль?",
    signup: "Регистрация",
    signin: "Войти",
    createAccount: "Создать Аккаунт",
    signupInfo: "Заполните форму ниже",
    passwordInfo: "Быстрый доступ с паролем",
    signupButton: "Создать Мой Аккаунт",
    signinButton: "Войти",
    passwordTooShort: "Пароль должен содержать не менее 6 символов",
    emailAlreadyExists: "Этот email уже используется",
    emailExistsHint: "✉️ Этот email уже зарегистрирован. Попробуйте войти! (Может быть, создан из другой игры?)",
    switchToSignin: "🔑 Переключитесь в режим входа с вашим существующим email",
    invalidCredentials: "Неверный email или пароль",
    signupSuccess: "📧 Аккаунт создан! Проверьте email для подтверждения регистрации.",
    emailConfirmationRequired: "Проверьте входящие сообщения для активации аккаунта",
    checkSpamFolder: "Не забудьте проверить папку спам",
    connectionSuccess: "✅ Успешный вход!",
    errorSignup: "Ошибка при регистрации"},
  
  install: {
    title: "Установить приложение",
    subtitle: "Быстрый доступ и оффлайн",
    feature1: "Мгновенный запуск с главного экрана",
    feature2: "Работает оффлайн после установки",
    feature3: "Опыт нативного приложения",
    feature4: "Не требуется загрузка из магазина",
    install: "Установить",
    dismiss: "Позже",
    info: "Вы можете удалить приложение в любое время"
  },
  
  ranks: {
    seeker: "Искатель",
    believer: "Пробуждённый",
    disciple: "Ученик",
    servant: "Служитель",
    witness: "Свидетель",
    guardian: "Страж",
    wise: "Мудрец",
    prophet: "Пророк",
    apostle: "Апостол",
    seekerDesc: "Начало духовного пути",
    believerDesc: "Пробуждённое духовное сознание",
    discipleDesc: "Изучение учений",
    servantDesc: "Служение и преданность",
    witnessDesc: "Разделение веры",
    guardianDesc: "Защита истины",
    wiseDesc: "Мудрость и знание",
    prophetDesc: "Духовное видение",
    apostleDesc: "Духовный мастер"
  },

  spiritualJourney: {
    beginning: "Начало духовного пути",
    progress: "Духовный прогресс",
    grade: "Степень",
    xp: "XP",
    level: "Уровень",
    nextGrade: "Следующая степень",
    still: "Еще",
    maxLevelReached: "Достигнут Максимальный Уровень!",
    masteredAllTeachings: "Вы овладели всеми учениями",
    progression: "Прогрессия"
  },
  
  treasures: {
    title: "💎 Сокровища Библии",
    verse: "Стих дня",
    fact: "Знаете ли вы?",
    treasure: "Скрытое сокровище",
    question: "Забавный вопрос",
    context: "Контекст",
    strongReference: "Библейская ссылка для углубленного изучения",
    verseOfDay: "✨ Стих дня",
    didYouKnow: "🌟 Знаете ли вы?",
    hiddenTreasure: "📜 Скрытое сокровище",
    funnyQuestion: "🤔 Забавный вопрос",
    emmanuelMemo: "Заметка Эммануила",
    emmanuelMessage: "Вы достигли вершины горы, и знание приобретено. Но непоколебимая вера требует жизненного опыта, милосердия и истинной любви Иисуса. Различные испытания жизни проверят ваш путь, истинный путь, который мы выбираем, наше сердце. Мы остаемся несовершенными, наши желания многочисленны, и любовь к наживе или к нашему личному комфорту слишком часто становится нашим эгоистичным приоритетом. Просите у Бога мудрости, его любви, его силы, и смиренно признавайте свои слабости, ибо ничто не может быть скрыто от Него... Ничто. Нет необходимости путешествовать в приватном режиме, использовать VPN или даже удалять историю. Поститесь, как Даниил: лишите себя на время того, что вы любите больше всего, в спокойствии и мудрости. Это позволит вам лучше слышать Бога, иметь расположение сердца, готовое к глубоким - и часто болезненным - преобразованиям. Тогда сны и видения станут яснее, как у Иосифа. Но остерегайтесь гордыни: не поддавайтесь 'Я всегда прав' или 'Я знаю лучше'. Ибо откровение Бога - это необыкновенная благодать. Не становитесь учителем Закона, способным снова распять Иисуса сегодня, Того, Кто просто просит любить ближнего... и предоставить им ту же свободу, которую вы получаете. Иметь веру означает вступить в свободные отношения и путешествие сердца. Это сделает вас могучими героями, способными на невозможное. Ибо опыт сверхъестественного, присутствие Бога, его подтверждение или благословение сделают вас поистине непоколебимыми.",
    jesusIsNot: "❌ Важное уточнение",
    clarification: "Важное уточнение",
    bibleOffline: "Читать Библию Офлайн",
    bibleStudy: "Библейское изучение",
    version: "Версия",
    openReader: "Открыть читалку",
    features: "Функции"
  },
  
  messages: {
    chooseCard: "⚡ Выберите вашу карту силы",
    cardHelp: "Она будет сопровождать вас в 3 вопросах этого уровня",
    chooseAnswer: "📖 Выберите ваш ответ:",
    wrongAnswer: "❌ Неправильный ответ! У вас осталось {lives} жизней. Попробуйте снова!",
    levelCompleted: "Уровень {level} Завершен",
    questionsProgress: "Вопрос {current} из 3",
    starsCollected: "Собрано звезд: {current}/{total}",
    pointsEarned: "+{points} Очков Мудрости",
    defeatedQuote: "Все могу в укрепляющем меня",
    chapter: "Глава",
    chapterStars: "звезды главы",
    totalGlobal: "Общий итог",
    backToMenu: "Вернуться в Меню"
  },
  
  quotes: {
    wisdom: "Начало мудрости — страх Господень",
    faith: "Все могу в укрепляющем меня Иисусе Христе",
    hope: "Господь — Пастырь мой; я ни в чем не буду нуждаться",
    love: "Ибо так возлюбил Бог мир...",
    perseverance: "Вера требует настойчивости",
    defeat: "Неудача приглашает расти в познании"
  },

  cards: {
    faith: "ВЕРА",
    courage: "МУЖЕСТВО",
    wisdom: "МУДРОСТЬ",
    faithKnowledge: "+50% очков",
    courageKnowledge: "Второй шанс",
    wisdomKnowledge: "Подсказка + бонус",
    faithDesc: "Максимум полученных очков мудрости",
    courageDesc: "Обычные очки, но второй шанс",
    wisdomDesc: "Раскрытая подсказка и +25% очков",
    chooseCard: "✨ Выберите дар знания",
    cardEffects: "✨ Эффекты даров знания:",
    faithEffect: "+50% очков мудрости - Максимальная награда",
    courageEffect: "Обычные очки, но второй шанс при ошибке",
    wisdomEffect: "+25% очков + раскрытая подсказка для каждого вопроса",
    chooseWisely: "Выбирайте мудро, ваш выбор будет сопровождать вас на протяжении всего уровня"
  },

  challenge: {
    loading: "Загрузка уровня...",
    peace: "🕊️ Пусть мир пребудет в вашем доме",
    questionsAwaiting: "🎯 Вас ждут 3 вопроса знания",
    starsQuote: "Каждая звезда - это шаг к божественному свету"
  },

  chapters: {
    "1": "Бытие",
    "2": "Исход",
    "3": "Иисус Христос",
    "4": "Распятие/Воскресение",
    "5": "Ранняя Церковь",
    "6": "Миссии Павла",
    "7": "Послания/Откровение",
    "8": "Бонусный уровень"
  },

  bible: {
    readerTitle: "📖 Читалка Библии",
    loading: "Загрузка Писаний...",
    menu: "Меню",
    strong: "Strong",
    strongReferences: "Ссылки Strong",
    verses: "стихи",
    previous: "Назад",
    next: "Далее",
    strongDefinition: "Ссылка Strong",
    word: "Оригинальное слово",
    transliteration: "Транслитерация",
    pronunciation: "Произношение",
    meaning: "Значение",
    definition: "Полное определение",
    usage: "Библейское использование",
    etymology: "Этимология",
    close: "Закрыть",
    moreReferences: "и {{count}} других ссылок",
    copyright: "📖 Synodal 1876 - Общественное достояние • Номера Strong включены"
  },

  philosophy: {
    title: "Философское измерение",
    loveOntology: "Любовь как онтологический принцип",
    loveDescription: "Иисус превращает любовь в метафизический фундамент: любовь к Богу и ближнему становится самой структурой подлинного бытия. Любовь выходит за рамки морали, становясь способом существования.",
    newCommandment: "Новая Заповедь",
    jesusEmphasizes: "Когда Иисус дает новую заповедь, он подчеркивает глагол любить",
    loveGod: "Люби Бога всем сердцем",
    loveNeighbor: "Люби ближнего своего, как самого себя",
    lovePriority: "Любовь становится приоритетом"
  },

  footer: {
    version: "Версия 1.0 • 2024",
    dedication: "Разработано во славу Божию"
  },

  endCredits: {
    lines: [
      { text: "Ты достиг вершины горы", delay: 2000 },
      { text: "Ты многому научился", delay: 2000 },
      { text: "Твоя вера растет каждый день", delay: 2000 },
      { text: "Ты переживаешь прекрасное с Богом", delay: 2000 },
      { text: "Трудности помогают тебе расти", delay: 2000 },
      { text: "Они показывают, что важно", delay: 2000 },
      { text: "Будь смиренным, как малое дитя", delay: 2000 },
      { text: "Бог любит твое простое сердце", delay: 2000 },
      { text: "В тишине ты слышишь Бога", delay: 2000 },
      { text: "Пост освобождает твой дух", delay: 2000 },
      { text: "Молись, и Бог поведет тебя", delay: 2000 },
      { text: "Гордость скрывает истину", delay: 2000 },
      { text: "Благодать Божия величественна", delay: 2000 },
      { text: "Она исходит из сердца Божия", delay: 2000 },
      { text: "Истинная вера делает тебя свободным", delay: 2000 },
      { text: "Она соединяет тебя с Богом навеки", delay: 2000 },
      { text: "Любовь может все изменить", delay: 2000 },
      { text: "Она может творить чудеса", delay: 2000 },
      { text: "Повтори за мной", delay: 2000 },
      { text: "Иисус, я отдаю Тебе мое сердце", delay: 3000 },
      { text: "Ты мой царь, мой спаситель", delay: 3000 },
      { text: "Приди, преобрази мою жизнь", delay: 3000 },
      { text: "Путь продолжается сейчас", delay: 2000 },
      { text: "Поделись этим прекрасным светом", delay: 2000 },
      { text: "К жизни, которая никогда не кончается", delay: 2000 },
      { text: "Храни любовь в своем сердце", delay: 3000 },
      { text: "Как драгоценное сокровище", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "ПОЗДРАВЛЯЕМ!",
      proud: "МЫ ГОРДИМСЯ ТОБОЙ",
      courage: "ОТВАЖНЫЙ ВОИН",
      peace: "НЕСУЩИЙ МИР",
      child: "ДИТЯ БОЖИЕ",
      blessing: "ДА БЛАГОСЛОВИТ ТЕБЯ БОГ",
      continue: "Продолжить"
    }
  },

  mountain: {
    spiritualAscension: "Духовное восхождение",
    levelProgress: "Уровень {{level}} • {{stars}} звезд получено",
    combo: "Комбо",
    perfectMessage: "\"Ибо мои мысли - не ваши мысли\" - Агнец поднимается к совершенной мудрости",
    goodMessage: "\"Ищите и найдете\" - Восхождение к истине продолжается",
    startMessage: "\"Вера, даже маленькая как горчичное зерно\" - Первый шаг к свету",
    skipAnimation: "Пропустить анимацию",
    chapter: "Глава",
    chapterProgress: "Глава {{current}}/{{total}}",
    secret: "Секрет",
    waypoints: {
      start: "Начало",
      firstSlope: "Первый склон",
      lastSlope: "Последний склон"
    },
    status: {
      defeat: "Поражение",
      inProgress: "В процессе",
      victory: "Победа"
    }
  },

  validation: {
    pseudoTooShort: "Имя пользователя должно содержать не менее 2 символов",
    enterPseudo: "Пожалуйста, введите имя пользователя"
  },

  pseudoSetup: {
    title: "Выберите имя пользователя",
    confirm: "Подтвердить Имя"
  },

  navigation: {
    back: "Назад"
  },

  console: {
    starsUnlocked: "звезды достигнуты! Разблокировка главы",
    defeatAnimation: "Поражение... И.Х. спускается"
  },

  errors: {
    progressionError: "Ошибка прогресса",
    invalidProgressionData: "Недопустимые данные прогресса:"
  },

  levels: {
    chaptersAndBonus: "8 глав + бонусный уровень",
    bonusUnlocked: "🏆 БОНУСНЫЙ УРОВЕНЬ РАЗБЛОКИРОВАН! Вы достигли духовного совершенства!",
    starsToDiscover: "273 {stars} для открытия",
    starsPerLevel: "3 {stars} за уровень"
  },

  architecture: {
    title: "🔧 Техническая архитектура",
    react: {
      name: "React",
      description: "Современный интерфейс"
    },
    modules: {
      name: "Модули",
      description: "Динамическая загрузка"
    },
    localStorage: {
      name: "LocalStorage",
      description: "Локальное хранилище"
    },
    tailwind: {
      name: "Tailwind",
      description: "Отзывчивый дизайн"
    }
  },

  info: {
    title: "Unity Quest Хроники Мира",
    subtitle: "Интерактивное изучение Писаний",
    yourStats: "Ваша Статистика",
    score: "Счет",
    wisdom: "Мудрость",
    revelation: "Откровение",
    createdWith: "Создано с ❤️",
    creator: "Emmanuel Payet",
    developerPassionate: "Разработчик, увлеченный духовностью",
    artistModule: "Emmanuel Художник",
    artistPortfolio: "Художественное портфолио и цифровые творения",
    features: "Особенности",
    multipleChapters: "91 уровень, распределенный по 8 библейским главам",
    powerCards: "3 уникальные карты силы (Вера, Смелость, Мудрость)",
    progressionSystem: "Система прогресса с духовными рангами",
    bibleTreasures: "Библейские сокровища и интересные факты",
    howToPlay: "Как Играть",
    selectLevel: "Выберите разблокированный уровень",
    choosePowerCard: "Выберите свою карту силы",
    answerQuestions: "Ответьте на 3 вопроса знания",
    earnStars: "Зарабатывайте звезды в зависимости от оставшихся жизней",
    tips: "Советы",
    readCarefully: "Внимательно читайте каждый вопрос",
    useWisdomCard: "Используйте карту Мудрости для подсказок",
    courageGivesSecondChance: "Карта Смелости дает вам второй шанс",
    faithMaximizes: "Карта Веры максимизирует ваши очки",
    johnGospelTitle: "Евангелие от Иоанна",
    johnGospelStats: "21 глава • 878 стихов • 14 языков",
    bibleReaderStrong: "Читалка Библии + Strong",
    bibleReaderStrongDesc: "Полное чтение со словарем Strong",
    johnTreasures: "Сокровища Иоанна",
    johnTreasuresDesc: "Библейские сокровища и интересные факты",
    quickAccessChapters: "Быстрый доступ к знаменитым главам:",
    johnChapter1: "Пролог",
    johnChapter3: "Рождение свыше",
    johnChapter14: "Я есмь путь",
    johnChapter20: "Воскресение",
    version: "Версия",
    madeWithLove: "Сделано с любовью во славу Божию",
    backToMenu: "Вернуться в Меню"
  },

  bible: {
    readerTitle: "📖 Читалка Библии",
    johnReaderTitle: "Читалка Библии - Евангелие от Иоанна",
    john: "Иоанн",
    loading: "Загрузка Писаний...",
    loadingChapter: "Глава {chapter} Евангелия от Иоанна. Полные данные загружаются...",
    exploreWhileLoading: "Тем временем вы можете изучить другие главы или использовать функцию поиска.",
    menu: "Меню",
    tabBible: "Библия",
    tabUnity: "Единство",
    strong: "Strong",
    strongReferences: "Ссылки Strong",
    verses: "стихов",
    previous: "Предыдущий",
    next: "Следующий",
    strongDefinition: "Ссылка Strong",
    word: "Оригинальное слово",
    transliteration: "Транслитерация",
    close: "Закрыть",
    share: "Поделиться",
    shareVerse: "Поделиться этим стихом",
    shareSelection: "Поделиться выбранным",
    pronunciation: "Произношение",
    meaning: "Значение",
    definition: "Полное определение",
    usage: "Библейское использование",
    etymology: "Этимология",
    search: "Поиск...",
    definitionNotFound: "Определение не найдено",
    definitionLoading: "Определение загружается...",
    imageFeatureComing: "🖼️ Функция изображений скоро появится!",
    copyError: "Ошибка при копировании:",
    error: "❌ Ошибка",
    errorLoading: "Ошибка загрузки",
    retry: "Попробовать снова",
    readerInDevelopment: "Читалка Библии Иоанна в разработке...",
    verseCopied: "Стих скопирован в буфер обмена!",
    moreReferences: "и {{count}} других ссылок",
    copyright: "📖 LSG 1910 • Strong включен",
    markAsRead: "Отрывок прочитан",
    alreadyRead: "Уже прочитано",
    readingBonus: "Бонус за чтение",
    results: "результатов",
    result: "результат",
    copy: "Копировать",
    image: "Изображение"
  },

  mountain: {
    chapter: "Глава",
    secret: "Секрет!",
    spiritualAscension: "Духовное Восхождение",
    levelProgress: "Уровень {{level}} • {{stars}} звезд получено",
    combo: "Комбо",
    perfectMessage: '"Ибо мои мысли - не ваши мысли" - Агнец поднимается к совершенной мудрости',
    goodMessage: '"Ищите, и найдете" - Восхождение продолжается к истине',
    startMessage: '"Вера, даже малая как горчичное зерно" - Первый шаг к свету',
    skipAnimation: "Пропустить анимацию",
    stats: {
      points: "очк",
      level: "Ур."
    },
    waypoints: {
      start: "Старт",
      firstSlope: "Первый склон",
      lastSlope: "Последний склон"
    },
    status: {
      victory: "Победа!",
      defeat: "Поражение",
      inProgress: "В процессе"
    }
  },

  bibleResources: {
    inAppReader: {
      name: "Читать в Приложении",
      description: "Встроенная читалка Библии со Strong",
      features: {
        offline: "Офлайн",
        strong: "Номера Strong",
        navigation: "Навигация"
      }
    }
  },

  quotes: {
    wisdom: "Истинное знание ведет к вечной мудрости",
    faith: "Все могу в укрепляющем меня",
    hope: "Господь - пастырь мой, не буду нуждаться",
    love: "Ибо так возлюбил Бог мир...",
    perseverance: "Вера требует настойчивости",
    defeat: "Неудача приглашает расти в знании"
  },

  philosophy: {
    title: "Философское измерение",
    loveOntology: "Любовь как онтологический принцип",
    loveDescription: "Иисус превращает любовь в метафизический фундамент: любить Бога и ближнего становится самой структурой подлинного бытия. Любовь выходит за рамки морали, становясь способом существования.",
    newCommandment: "Новая Заповедь",
    jesusEmphasizes: "Когда Иисус дает новую заповедь, он подчеркивает глагол любить",
    loveGod: "Люби Бога всем сердцем твоим",
    loveNeighbor: "Люби ближнего своего как самого себя",
    lovePriority: "Любовь становится приоритетом"
  },

  unity: unityTranslations,

  footer: {
    version: "Версия 1.0 • 2024",
    dedication: "Разработано во славу Божию"
  },

  endCredits: {
    lines: [
      { text: "Ты достиг вершины горы", delay: 2000 },
      { text: "Ты узнал много нового", delay: 2000 },
      { text: "Твоя вера растет каждый день", delay: 2000 },
      { text: "Ты переживаешь прекрасное с Богом", delay: 2000 },
      { text: "Трудности помогают тебе расти", delay: 2000 },
      { text: "Они показывают, что важно", delay: 2000 },
      { text: "Будь смиренным как дитя", delay: 2000 },
      { text: "Бог любит твое простое сердце", delay: 2000 },
      { text: "В тишине ты слышишь Бога", delay: 2000 },
      { text: "Пост освобождает твой дух", delay: 2000 },
      { text: "Молись, и Бог направит тебя", delay: 2000 },
      { text: "Гордыня скрывает истину", delay: 2000 },
      { text: "Благодать Бога великолепна", delay: 2000 },
      { text: "Она исходит из сердца Бога", delay: 2000 },
      { text: "Истинная вера делает тебя свободным", delay: 2000 },
      { text: "Она соединяет тебя с Богом навсегда", delay: 2000 },
      { text: "Любовь может все изменить", delay: 2000 },
      { text: "Она может творить чудеса", delay: 2000 },
      { text: "Повтори за мной", delay: 2000 },
      { text: "Иисус, я отдаю Тебе свое сердце", delay: 3000 },
      { text: "Ты мой царь, мой спаситель", delay: 3000 },
      { text: "Приди и преобрази мою жизнь", delay: 3000 },
      { text: "Путь продолжается теперь", delay: 2000 },
      { text: "Поделись этим прекрасным светом", delay: 2000 },
      { text: "К жизни, которая никогда не кончается", delay: 2000 },
      { text: "Храни любовь в своем сердце", delay: 3000 },
      { text: "Как драгоценное сокровище", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "ПОЗДРАВЛЯЕМ!",
      proud: "МЫ ГОРДИМСЯ ТОБОЙ",
      courage: "СМЕЛОСТЬ ОТВАЖНЫЙ",
      peace: "НОСИТЕЛЬ МИРА",
      child: "ДИТЯ БОЖЬЕ",
      blessing: "ДА БЛАГОСЛОВИТ ТЕБЯ БОГ",
      continue: "Продолжить"
    }
  },

  validation: {
    pseudoTooShort: "Псевдоним должен содержать не менее 2 символов",
    enterPseudo: "Пожалуйста, введите псевдоним"
  },

  pseudoSetup: {
    title: "Выберите свой игровой псевдоним",
    profileConfig: "Настройка Профиля",
    connectedWith: "Подключено с",
    playerPseudo: "Игровой Псевдоним",
    pseudoPlaceholder: "Ваш псевдоним...",
    pseudoRequirements: "2-20 символов • Отображается в рейтингах",
    suggestions: "Предложения",
    confirm: "Подтвердить Псевдоним",
    errorConfig: "Ошибка при настройке"
  },

  navigation: {
    back: "Назад"
  },

  console: {
    starsUnlocked: "звезд достигнуто! Разблокировка главы",
    defeatAnimation: "Поражение... И.Х. спускается"
  },

  errors: {
    progressionError: "Ошибка прогресса",
    invalidProgressionData: "Недействительные данные прогресса:"
  },

  levels: {
    chaptersAndBonus: "8 глав + бонусный уровень",
    bonusUnlocked: "🎊 БОНУСНЫЙ УРОВЕНЬ РАЗБЛОКИРОВАН! Ты достиг духовного совершенства!",
    starsToDiscover: "273 {stars} для открытия",
    starsPerLevel: "3 {stars} за уровень"
  },

  architecture: {
    title: "🏗️ Техническая архитектура",
    react: {
      name: "React",
      description: "Современный интерфейс"
    },
    modules: {
      name: "Модули",
      description: "Динамическая загрузка"
    },
    localStorage: {
      name: "LocalStorage",
      description: "Локальное сохранение"
    },
    tailwind: {
      name: "Tailwind",
      description: "Адаптивный дизайн"
    }
  },

  gameManager: {
    title: "Сохранение игры",
    saveLocal: "Локальное сохранение",
    saveCloud: "Облако синхронизировано",
    saveWaiting: "Ожидание подключения",
    lastSave: "Последнее сохранение:",
    never: "Никогда",
    saving: "Сохранение...",
    save: "Сохранить",
    loadProgress: "Загрузить",
    loading: "Загрузка...",
    autoSaveEnabled: "💾 Автосохранение включено",
    saveError: "❌ Ошибка сохранения",
    gameSaved: "✅ Игра сохранена!",
    gameLoaded: "📥 Игра загружена!"
  }
};

export default uiTranslations;
